import { render, staticRenderFns } from "./verificationCards.vue?vue&type=template&id=7024d3d5&"
import script from "./verificationCards.vue?vue&type=script&lang=js&"
export * from "./verificationCards.vue?vue&type=script&lang=js&"
import style0 from "./verificationCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports